import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type SubCategory = {
  id: ID;
  goal: Goal;
  subCategories: SubCategory[];
};

export type Category = {
  id: ID;
  subCategories: SubCategory[];
  lifeArea: LifeArea;
};

export type SideBarItemBase = {
  id: ID;
  level: number;
  hasGoals?: boolean;
};

export type SideBarItemGoal = SideBarItemBase & {
  goal: Goal;
};

export type SideBarItemLifeArea = SideBarItemBase & {
  lifeArea: LifeArea;
};

export type SideBarItem = SideBarItemGoal | SideBarItemLifeArea;

export enum ReorderPositions {
  Before = 'before',
  After = 'after',
  Inside = 'inside',
  InsideCategory = 'inside-category',
}

export type DragState = {
  draggedId: string | null;
  dropTargetId: string | null;
  dropPosition: ReorderPositions | null;
};
